
<div>

  <h4>
    Detalles de Venta de Reses
  </h4>

  <button class="btn btn-secondary"
          (click)="close()">
    Cerrar
  </button>

  <hr />

  <app-header-details #saleDetails></app-header-details>

  <h5 class="text-center">
    Total: {{ saleTotalPrice | currency }}
  </h5>

  <hr />

  <div class="row">
    <div class="col-md-10 col-sm-12 mx-auto">
      <app-list-details #customerDetails></app-list-details>
      <hr />

      <app-list-details #cageDetails></app-list-details>
      <hr />

      <app-square-details #animalsList></app-square-details>
      <hr />

      <app-simple-grid #cutsGrid></app-simple-grid>
    </div>
  </div>

</div>
